import Tooltip from "@mui/material/Tooltip";
import classNames from "classnames";
import { NAVIGATION_NAME, SidebarItem } from "interfaces/Navigation";
import { Link } from "react-router-dom";

type Props = {
  currentSection: string;
  setCurrentSection: (name: NAVIGATION_NAME) => void;
  navigation: SidebarItem[];
};

export const NavigationContainer = ({ currentSection, navigation }: Props) => {
  const filteredNavigation = navigation.filter((nav) => nav.icon);

  return (
    <nav className="flex flex-1 flex-col space-y-5 justify-center">
      {filteredNavigation.map((item, index: number) => (
        <Tooltip title={item.name} key={`${index}-${item.name}`}>
          <Link
            to={item.href}
            key={item.name}
            className={classNames(
              currentSection === item.name
                ? "bg-faux-ultramarine-blue text-white"
                : "hover:bg-faux-ultramarine-blue hover:bg-opacity-50 hover:text-white text-faux-black-coral",
              "group flex items-center justify-center rounded-md p-2",
            )}
          >
            <item.icon
              className="flex-shrink-0 h-6 w-6 text-primary-300"
              aria-hidden="true"
            />
          </Link>
        </Tooltip>
      ))}
    </nav>
  );
};
